<template>
  <div class="wrapper">
    <div v-if="loadComplete" >
      <root-sidebar v-if="loadComplete && isEmailVerified && !loadError && !userNeedsOnboard"></root-sidebar>
      <div class="main-content">
        <root-navbar></root-navbar>
        <div v-if="!isEmailVerified">
          <email-verification-page></email-verification-page>
        </div>
        <div v-else-if="loadError !== undefined">
          <permission-denied-page v-if="loadError.code === 7" :message="loadError.message"></permission-denied-page>
          <error-page :error="loadError" v-else></error-page>
        </div>
        <div v-else-if="userNeedsOnboard">
          <onboard-form-wizard></onboard-form-wizard>
        </div>
        <div v-else>
          <!--            <notifications></notifications>-->
          <root-content></root-content>
        </div>
        <root-footer v-if="!$route.meta.hideFooter"></root-footer>
      </div>
    </div>
    <div v-else class="text-center p-3">
      <div> Loading... </div>
      <b-spinner size="sm"></b-spinner>
      <root-footer v-if="!$route.meta.hideFooter"></root-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import '#/ui/dark-mode.scss';

import { mapGetters } from 'vuex';
import RootSidebar from '#/ui/Layout/RootSidebar.vue';
import RootNavbar from '#/ui/Layout/RootNavbar.vue';
import RootFooter from '#/ui/Layout/RootFooter.vue';
import RootContent from '#/ui/Layout/RootContent.vue';

import EmailVerificationPage from '#/ui/Pages/EmailVerificationPage.vue';
import OnboardFormWizard from '#/ui/Components/Onboard/OnboardFormWizard.vue';
import ErrorPage from '#/ui/Pages/General/ErrorPage.vue';
import PermissionDeniedPage from '#/ui/Pages/General/PermissionDeniedPage.vue';

import { notification } from './toast/bus';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    ErrorPage,
    OnboardFormWizard,
    EmailVerificationPage,
    RootSidebar,
    RootNavbar,
    RootContent,
    RootFooter,
    PermissionDeniedPage,
  },
  created() {
    notification(this);
  },
  data() {
    return {
      darkMode: '',
    };
  },
  computed: {
    ...mapGetters({
      loadComplete: 'isInitialLoadComplete',
      loadError: 'loadError',
    }),
    ...mapGetters('user', {
      isEmailVerified: 'isEmailVerified',
      userNeedsOnboard: 'userNeedsOnboard',
    }),
  },
  methods: {
    initScrollbar() {
      const isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        initScrollbar('scrollbar-inner');
      }
    },
  },
  mounted() {
    this.initScrollbar();
    this.darkMode = window.localStorage.getItem('darkMode');
    console.log(this.darkMode);
    if (this.darkMode === 'true') {
      document.querySelector('body').classList.add('dark-mode');
    }
  },
};
</script>
<style lang="scss">
.navbar-heading {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.list-group {
    max-height: 500px;
    overflow-y:scroll;
    -webkit-overflow-scrolling: touch;
}
*::-webkit-scrollbar {
  width: 5px;
}

/* Track */
*::-webkit-scrollbar-track {
  background: #fff;
}

/* Handle */
*::-webkit-scrollbar-thumb {
  background: rgb(202, 200, 200);
}

/* Handle on hover */
*::-webkit-scrollbar-thumb:hover {
  background: rgb(168, 168, 168);
}
.hw-fixed {
  width: 274px !important;
}
.no-media {
  min-height: 100px !important;
}
.col-width {
  width: 40%;
}
.toggleView {
  padding-top: 9px !important;
}
</style>
